(function () {
    'use strict';

    let prevListItems = [];
    const deepNavHeader = document.querySelector('.deep-nav');

    function buildNav(navItems) {
        const currentNav = document.querySelector('.nav-items ul');
        prevListItems = [];
        currentNav.querySelectorAll('li').forEach(function (li) {
            let currentNavItem = {
                title: li.innerText,
            };

            if (li.querySelector('a')) {
                currentNavItem.url = li.querySelector('a').href;
            }

            if (li.querySelector('[data-deepnav]')) {
                currentNavItem.navigation =
                    li.querySelector('[data-deepnav]').dataset.deepnav;
            }

            prevListItems.push(currentNavItem);
        });
        currentNav.innerHTML = '';

        navItems.forEach(function (navItem) {
            const li = document.createElement('li');

            if (navItem.url) {
                const a = document.createElement('a');
                a.innerText = navItem.title;
                a.href = navItem.url;
                li.appendChild(a);
            }

            if (navItem.navigation) {
                const div = document.createElement('div');
                div.classList.add('cursor-pointer');
                div.dataset.deepnav = navItem.navigation;
                const span = document.createElement('span');
                span.innerText = navItem.title;
                const i = document.createElement('i');
                i.classList.add('fa');
                i.classList.add('fa-chevron-right');
                span.appendChild(i);
                div.appendChild(span);
                li.appendChild(div);
            }

            currentNav.appendChild(li);
        });
    }

    document.querySelectorAll('[data-deepnav]').forEach(function (el) {
        el.addEventListener('click', function (e) {
            const navItems = JSON.parse(e.currentTarget.dataset.deepnav);
            deepNavHeader.classList.add('-active');
            deepNavHeader.querySelector('.deep-nav-title').innerText =
                e.currentTarget.querySelector('span').innerText;
            buildNav(navItems);
        });
    });

    const deepNavBtn = document.querySelector('.deep-nav-btn');
    if (deepNavBtn) {
        deepNavBtn.addEventListener('click', function (e) {
            e.preventDefault();
            deepNavHeader.classList.remove('-active');
            buildNav(prevListItems);
        });
    }
})();
